module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm.ehVisualizacao ? 'Visualização da' : (_vm.ehAssinatura ? 'Assinar a ' : _vm.enumeradores[_vm.etapa] + ' de ')) + " Ratificação " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]), _vm._v(" "), (!_vm.ehAssinatura) ? _c('span', [(!_vm.loading.tela && !_vm.ehVisualizacao || (_vm._.includes(['SOLICITACAO', 'CONCLUSAO'], _vm.etapa)) || (_vm.etapa === 'ASSINATURA_RATIFICACAO' && _vm.ehAssinatura && _vm.usuarioPodeAssinar)) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.permiteConcluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.ehAssinatura) ? _c('span', [(!_vm.loading.tela && !_vm.ehVisualizacao || (_vm._.includes(['SOLICITACAO', 'CONCLUSAO'], _vm.etapa)) || (_vm.etapa === 'ASSINATURA_RATIFICACAO' && _vm.ehAssinatura && _vm.usuarioPodeAssinar)) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.permiteConcluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Assinar ")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading.tela) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.voltar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Remessa',
        href: '#'
      }, {
        text: 'Lista de Ratificações',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela && !_vm.usuarioPodeAssinar && _vm.ehAssinatura),
      expression: "!loading.tela && !usuarioPodeAssinar && ehAssinatura"
    }],
    staticClass: "alert alert-info mt-4",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Você não é destinatário desta ratificação.")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "edicaoRatificacao"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela || _vm.loading.usuarios),
      expression: "loading.tela || loading.usuarios"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('assunto')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "assunto_ratificacao"
    }
  }, [_vm._v("Assunto da ratificação?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratificacao.assunto),
      expression: "ratificacao.assunto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "assunto",
      "id": "assunto_ratificacao",
      "aria-hidden": "true",
      "disabled": _vm.ehVisualizacao || _vm.ehAssinatura || _vm.etapa !== 'SOLICITACAO'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ratificacao, "assunto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selecaoAssunto]
    }
  }, _vm._l((_vm.listaAssuntos), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), (_vm.errors.first('assunto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('assunto')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('solicitação')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "requerimento_ratificacao"
    }
  }, [_vm._v("Solicitação")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Descreva aqui a solicitação sobre o assunto selecionado",
      "name": "solicitação",
      "id": "requerimento_ratificacao",
      "disabled": _vm.ehVisualizacao || _vm.ehAssinatura
    },
    model: {
      value: (_vm.ratificacao.requerimento),
      callback: function($$v) {
        _vm.$set(_vm.ratificacao, "requerimento", $$v)
      },
      expression: "ratificacao.requerimento"
    }
  }), _vm._v(" "), (_vm.errors.first('solicitação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('solicitação')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('destinatario')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "alcada_ratificacao"
    }
  }, [_vm._v("Destinatário")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.loading.usuarios) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]) : _c('span', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaUsuarios,
      "multiple": true,
      "value": _vm.ds_nome_usuario,
      "disabled": _vm.ehVisualizacao || _vm.ehAssinatura || _vm.etapa !== 'SOLICITACAO',
      "custom-label": _vm.nomeUsuario,
      "placeholder": "Selecione um ou mais usuários",
      "label": "ds_nome_usuario",
      "track-by": "ds_nome_usuario",
      "preselect-first": false,
      "close-on-select": false,
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "selectedLabel": "",
      "name": "destinatario",
      "id": "alcada_ratificacao"
    },
    on: {
      "input": _vm.selecionandoDestinatario
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.ds_nome_usuario))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.ratificacao.alcada),
      callback: function($$v) {
        _vm.$set(_vm.ratificacao, "alcada", $$v)
      },
      expression: "ratificacao.alcada"
    }
  }, [_vm._v(" "), _c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('destinatario')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('destinatario')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'top'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
    }],
    staticClass: "col-md-4",
    attrs: {
      "title": '<h5>Dos destinatários selecionados qual a quantidade mínima de assinaturas são necessárias para o processo retornar</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label col-md-9",
    attrs: {
      "for": "qtde_assinaturas_obrigatorias"
    }
  }, [_vm._v("Quantidade de assinaturas obrigatórias")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratificacao.qtdeAssinaturasObrigatorias),
      expression: "ratificacao.qtdeAssinaturasObrigatorias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "qtde_assinaturas_obrigatorias",
      "disabled": _vm.ehVisualizacao || _vm.ehAssinatura || _vm.etapa !== 'SOLICITACAO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ratificacao, "qtdeAssinaturasObrigatorias", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l(((_vm._.isNull(_vm.ratificacao.alcada) ? 1 : _vm.ratificacao.alcada.length)), function(qtde) {
    return _c('option', {
      domProps: {
        "value": qtde
      }
    }, [_vm._v(_vm._s(qtde))])
  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('upload-documentos-ratificacao', {
    attrs: {
      "foiAssinada": _vm.foiAssinada,
      "processo_ratificacao": _vm.id,
      "propDocumentos": _vm.ratificacao.anexos,
      "documentTypes": '',
      "disable": _vm.ehVisualizacao || _vm.ehAssinatura,
      "local-uso": _vm.ratificacao.assunto.codigo
    }
  })], 1)]), _vm._v(" "), (!_vm._.isNull(_vm.id)) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.historico), function(tarefa) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(tarefa.termino, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.enumeradores[tarefa.nome]))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(tarefa.observacao))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(tarefa.nome === 'ASSINATURA_RATIFICACAO') ? _c('span', [(_vm._.includes(tarefa.resultado, 'Sim')) ? _c('span', [_c('i', {
      staticClass: "fa fa-check text-green",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : (_vm._.includes(tarefa.resultado, 'Nao')) ? _c('span', [_c('i', {
      staticClass: "fa fa-times text-red",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('span', {
      staticClass: "text-blue"
    }, [_vm._v("\n                            " + _vm._s(_vm.ratificacao.qtdeAssinaturasObrigatorias > _vm._.sumBy(_vm.historico, function(h) {
      return h.nome === 'ASSINATURA_RATIFICACAO' && _vm._.includes(h.resultado, 'Sim') ? 1 : 0
    }) ? 'Pendente' : '') + "\n                          ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(tarefa.ds_nome_usuario))])])
  }), 0)])])])]) : _vm._e()])])]), _vm._v(" "), (_vm.ehAssinatura && _vm.usuarioPodeAssinar) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "decisoes_aprovação"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('aprovacao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Aprovar solicitação?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratificacao.aprovacao),
      expression: "ratificacao.aprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "aprovacao",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": 'Sim',
      "checked": _vm._q(_vm.ratificacao.aprovacao, 'Sim')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ratificacao, "aprovacao", 'Sim')
      }
    }
  }), _vm._v(" Sim\n                                "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratificacao.aprovacao),
      expression: "ratificacao.aprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "aprovacao",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": 'Nao',
      "checked": _vm._q(_vm.ratificacao.aprovacao, 'Nao')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ratificacao, "aprovacao", 'Nao')
      }
    }
  }), _vm._v(" Não\n                                "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.errors.first('aprovacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('aprovacao')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "observacao_decisao"
    }
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratificacao.observacao),
      expression: "ratificacao.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao_decisao",
      "id": "observacao_decisao",
      "rows": "3",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.ratificacao.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ratificacao, "observacao", $event.target.value)
      }
    }
  })])])])])])])])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Solicitação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(" Anexos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Data de conclusão")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Fase")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Observação")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Aprovação")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Usuário Responsável")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Decisões")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d762c6b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/ratificacoes/EditaRatificacao.vue
// module id = 1854
// module chunks = 2